import {types} from '../types/types'

export const setEnviromentValue=(data)=>({
    type:types.setEnviromentValue,
    payload:data
})
